import { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import TimerIcon from '@material-ui/icons/TimerOutlined';
import appConstants from '../../../../../appConstants';
import { getHoursMinutesAndSecondsStr } from '../../../Dialogs/DynamicRouting/components/utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 6,
    marginLeft: 12,
    color: theme.iconColor
  },
  timerIcon: {
    fontSize: 16,
    marginRight: 2
  },
  timerValueItalic: {
    fontSize: 14,
    fontStyle: 'italic',
    fontWeight: 400
  },
  time: {
    marginLeft: 4,
    fontWeight: 600
  }
});

const PickupOperationTimer = ({ classes }) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setElapsedTime((prev) => {
        const newTime = prev + 1;
        return newTime;
      });
    }, appConstants.ONE_SECOND_TIME_OUT);

    return () => {
      clearInterval(timerRef.current);
    };
  }, []);

  return (
    <div className={classes.container}>
      <TimerIcon className={classes.timerIcon} />
      <span className={classes.timerValueItalic}>
        Processing time
        <span className={classes.time}>{getHoursMinutesAndSecondsStr(elapsedTime)}</span>
      </span>
    </div>
  );
};

export default withStyles(styles)(PickupOperationTimer);
